import React from "react";
import { Link } from "react-router-dom";
import banner from "../Images/rebar1.jpg";

export default function Aboutus() {
  return (
    <div className="bg-gray-100">

      {/* Hero Banner */}

      <section
        className="relative h-[320px] md:h-[380px] bg-cover bg-center"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <div className="absolute inset-0 bg-black/50"></div>

        <div className="relative z-10 flex items-center justify-center h-full">
          <div className="text-center text-white">

            <h1 className="text-4xl md:text-6xl font-bold">
              Company Profile
            </h1>

            <p className="mt-4 text-lg tracking-widest uppercase text-amber-400">
              Estimate & Detailing Rebar Service
            </p>

          </div>
        </div>
      </section>

      {/* Content Card */}

      <section className="-mt-20 relative z-20 pb-20">

        <div className="max-w-5xl mx-auto px-6">

          <div className="bg-white rounded-xl shadow-2xl p-8 md:p-14">

            <span className="uppercase tracking-[4px] text-amber-500 font-semibold">
              About Company
            </span>

            <h2 className="text-4xl font-bold text-slate-900 mt-3 mb-8">
              About EDRS
            </h2>

            <p className="text-gray-700 leading-9 text-lg mb-8">
              We are pleased to introduce ourselves as an emerging concern in
              the field of <strong>E&amp;D Rebar Service.</strong> We provide
              professional Rebar Estimation and Rebar Detailing services for
              projects following
              <strong> ACI / CRSI Standards (USA)</strong> and
              <strong> RSIC Standards (Canada)</strong>.
            </p>

            <p className="text-gray-700 leading-9 text-lg mb-8">
              Our experienced engineers, estimators and detailers have
              <strong> 4–8 years </strong>
              of construction experience across Buildings,
              Bridges,
              Tunnels,
              Water Treatment Plants,
              Commercial Buildings,
              Industrial Structures and Infrastructure Projects.
            </p>

            <p className="text-gray-700 leading-9 text-lg mb-10">
              We focus on delivering
              <strong> accurate, error-free estimation and detailing </strong>
              that helps contractors,
              fabricators,
              project engineers and site teams complete projects efficiently
              while reducing material waste and overall project cost.
            </p>

            {/* Commitment */}

            <div className="bg-amber-50 border-l-4 border-amber-500 rounded-lg p-8">

              <h3 className="text-2xl font-bold text-slate-900 mb-4">
                Our Commitment
              </h3>

              <p className="text-gray-700 leading-8">
                We are committed to providing our clients with accurate,
                thorough reinforcing steel estimates and precise, reliable
                detailing for reinforced concrete structures while maintaining
                quality, speed and customer satisfaction.
              </p>

            </div>

            <div className="mt-10">

              <Link
                to="/aboutus/keypersonals"
                className="inline-block bg-amber-500 hover:bg-amber-600 text-white px-8 py-4 rounded-lg font-semibold transition"
              >
                Meet Our Team →
              </Link>

            </div>

          </div>

        </div>

      </section>

    </div>
  );
}